import { styled } from '@mui/material';

export const KpiWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'count',
})<{ count: number }>(({ theme, count }) => ({
  background: theme.palette.background.default,
  padding: '14px',
  display: 'grid',
  width: '100%',
  gap: '10px',
  gridTemplateColumns: 'repeat(1, 1fr)',
  justifyContent: 'stretch',
  [theme.breakpoints.down('md')]: {
    gap: '8px',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: count === 1 ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(calc(25% - 10px), 1fr))',
  },
}));

export const ModuleWidgetWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  background: theme.palette.background.default,
  padding: '14px',
  gap: '10px',
  cursor: 'default',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

export const AgendaViewsWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '10px',
  background: theme.palette.background.default,
  padding: '14px',
}));
